import type { AuthType, UserRole, UserSetting } from "@/interfaces/profile";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface User {
  success: boolean;
  code: string;
  status?: string;
  userId?: string;
  isVerified?: boolean;
  message: string;
  kycStatus?: string;
  kycLevel?: number;
  twoFactorEnabled?: boolean;
  id: string;
  role: UserRole;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  image: string;
  authType: AuthType;
}

export interface SettingsState {
  setting: UserSetting | null;
  showBalance: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  setting: null,
  showBalance: true,
  isLoading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    getSettingsRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },

    getSettingsSuccess: (state, action: PayloadAction<UserSetting>) => {
      state.isLoading = false;
      state.setting = action.payload;
      state.error = null;
    },

    getSettingsFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    clearSetting: (state) => {
      state.setting = null;
      state.isLoading = false;
      state.error = null;
    },

    updateSetting: (state, action: PayloadAction<UserSetting>) => {
      state.setting = action.payload;
    },

    toggleBalance: (state) => {
      state.showBalance = !state.showBalance;
    },
  },
});

export const {
  getSettingsRequest,
  getSettingsSuccess,
  getSettingsFailure,
  clearSetting,
  updateSetting,
  toggleBalance,
} = settingsSlice.actions;
export default settingsSlice.reducer;
